import AppContainer from './container/AppContainer'

import './app.scss'

export {default as AppLayout} from './components/AppComponent'
export default AppContainer
